var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBodyComp = function SvgIconBodyComp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.999 17.857C20.851 18.402 22 19.161 22 20c0 1.657-4.477 3-10 3S2 21.657 2 20c0-.839 1.149-1.598 3-2.142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20h-4v-5H8v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5h-2zM12 5a2 2 0 0 1-2-2h0a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2h0a2 2 0 0 1-2 2"
  })))));
};
export { SvgIconBodyComp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTguOTk5IDE3Ljg1N0MyMC44NTEgMTguNDAyIDIyIDE5LjE2MSAyMiAyMGMwIDEuNjU3LTQuNDc3IDMtMTAgM1MyIDIxLjY1NyAyIDIwYzAtLjgzOSAxLjE0OS0xLjU5OCAzLTIuMTQyIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNCAyMGgtNHYtNUg4di01YTIgMiAwIDAgMSAyLTJoNGEyIDIgMCAwIDEgMiAydjVoLTJ2NXpNMTIgNWgwYTIgMiAwIDAgMS0yLTJoMGEyIDIgMCAwIDEgMi0yaDBhMiAyIDAgMCAxIDIgMmgwYTIgMiAwIDAgMS0yIDJ6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";